var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-card-wrapper pt-4 pb-5 pr-2" },
    [
      _c("div", { staticClass: "eh-section-title pb-1" }, [
        _vm._v(_vm._s(_vm.cardData.title))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-card-description pb-4" }, [
        _vm._v(_vm._s(_vm.cardData.description))
      ]),
      _vm._v(" "),
      _vm._l(_vm.cardData.actions, function(action, i) {
        return _c("div", { key: i, staticClass: "pb-2" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !action.isHidden,
                  expression: "!action.isHidden"
                }
              ]
            },
            [
              _c(
                "div",
                { staticClass: "d-inline-block" },
                [
                  action.url
                    ? _c(
                        "external-link",
                        {
                          attrs: {
                            "href-url": action.url,
                            target: action.target,
                            event: _vm.event,
                            "sub-event": _vm.createSubEvent(
                              _vm.cardData,
                              action
                            )
                          }
                        },
                        [_vm._v(_vm._s(action.text))]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "eh-link",
                          on: {
                            click: function($event) {
                              return _vm.triggerAction(_vm.cardData, action)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(action.text) +
                              "\n          "
                          ),
                          _c("font-awesome-icon", {
                            staticClass: "ml-1",
                            attrs: { icon: "external-link-alt", size: "sm" }
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              action.note
                ? _c(
                    "div",
                    { staticClass: "contact-card-action-note d-inline-block" },
                    [_vm._v("\n        " + _vm._s(action.note) + "\n      ")]
                  )
                : _vm._e()
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af72af3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af72af3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact-support/ContactCard.vue
// module id = null
// module chunks = 